document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector<HTMLElement>(
    '[data-role="globalHeader"]'
  );
  const content = document.querySelector<HTMLElement>(
    '[data-role="contentBody"]'
  );
  const topMv = document.querySelector<HTMLElement>('[data-role="topMv"]');

  if (!header) return;

  let lastScrollY = window.scrollY;

  /**
   * 2. ナビゲーション制御：ハンバーガーメニューの開閉
   */
  const initNavigation = (): void => {
    const navBtn = document.querySelector<HTMLButtonElement>(
      '[data-role="navBtn"]'
    );
    const slideNav = document.querySelector<HTMLElement>(
      '[data-role="slideNav"]'
    );
    const menuText = navBtn?.querySelector<HTMLSpanElement>(
      'span.text-\\[13px\\]'
    );

    if (!navBtn || !slideNav || !menuText) return;

    const closeMenu = () => {
      navBtn.classList.remove('open');
      slideNav.classList.remove('active');
      menuText.textContent = 'MENU';

      // メニューを閉じた際、スクロール位置がトップならfixedを外す（既存ロジックとの整合性）
      if (window.scrollY <= 0 && !topMv) {
        header.classList.remove('fixed');
      } else if (topMv) {
        const mvRect = topMv.getBoundingClientRect();
        if (mvRect.bottom >= 0) {
          header.classList.remove('fixed');
        }
      }
    };

    navBtn.addEventListener('click', () => {
      const isOpen = navBtn.classList.toggle('open');
      slideNav.classList.toggle('active');

      if (isOpen) {
        menuText.textContent = 'close';
        header.classList.add('fixed'); // 【追記】メニュー開画時にfixedを付与
      } else {
        menuText.textContent = 'MENU';
        // 【追記】閉じた時、スクロール位置に応じてfixedを維持するか判定
        handleHeaderScroll();
      }
    });

    slideNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    slideNav.addEventListener('click', (e) => {
      if (e.target === slideNav) closeMenu();
    });
  };

  /**
   * 3. ヘッダー追従：固定タイミングとスクロール方向の出し入れ
   */
  const handleHeaderScroll = (): void => {
    // 【追記】メニューが開いている時は、スクロールによるfixed解除をスキップ
    const navBtn = document.querySelector('[data-role="navBtn"]');
    if (navBtn?.classList.contains('open')) return;

    const currentScrollY = window.scrollY;

    // --- A. 固定(fixed)にするタイミングの制御 ---
    if (topMv) {
      const mvRect = topMv.getBoundingClientRect();
      if (mvRect.bottom < 0) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed', 'is-show', 'is-hide');
      }
    } else {
      if (currentScrollY > 0) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed', 'is-show', 'is-hide');
      }
    }

    // --- B. スクロール方向による出し入れ ---
    if (!header.classList.contains('fixed')) return;

    const diff = currentScrollY - lastScrollY;
    if (Math.abs(diff) < 5) return;

    if (diff > 0) {
      header.classList.add('is-show');
      header.classList.remove('is-hide');
    } else {
      header.classList.add('is-hide');
      header.classList.remove('is-show');
    }

    lastScrollY = currentScrollY;
  };

  // --- 実行とリスナー登録 ---
  initNavigation();
  window.addEventListener('scroll', handleHeaderScroll, { passive: true });
  handleHeaderScroll();

  const initMobileAccordion = (): void => {
    const triggers = document.querySelectorAll<HTMLElement>(
      '[data-role="slideDown"]'
    );
    const LG_BREAKPOINT = 1024;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        // lgサイズ（1024px）以上の場合は実行しない
        if (window.innerWidth >= LG_BREAKPOINT) return;

        const nextUl = trigger.nextElementSibling;

        if (nextUl instanceof HTMLUListElement) {
          // 表示・非表示の判定
          const isOpening =
            nextUl.style.display === 'none' || !nextUl.style.display;

          if (isOpening) {
            nextUl.style.display = 'block';
            trigger.classList.add('open'); // openクラスを付与
          } else {
            nextUl.style.display = 'none';
            trigger.classList.remove('open'); // openクラスを削除
          }
        }
      });
    });

    // リサイズ時にPCサイズになったらスタイルをリセットする処理（推奨）
    window.addEventListener('resize', () => {
      if (window.innerWidth >= LG_BREAKPOINT) {
        triggers.forEach((trigger) => {
          trigger.classList.remove('open');
          const nextUl = trigger.nextElementSibling;
          if (nextUl instanceof HTMLUListElement) {
            nextUl.style.removeProperty('display');
          }
        });
      }
    });
  };

  initMobileAccordion();

  const dropdown = document.getElementById(
    'lang-dropdown'
  ) as HTMLElement | null;
  const langBtn = document.getElementById(
    'lang-btn'
  ) as HTMLButtonElement | null;

  if (dropdown && langBtn) {
    // メニューの開閉
    langBtn.addEventListener('click', (e: MouseEvent): void => {
      e.stopPropagation(); // documentのクリックイベントに流さない
      dropdown.classList.toggle('active');
    });

    // メニュー内のリンクをクリックしたら閉じる
    const links = dropdown.querySelectorAll('a');
    links.forEach((link: HTMLAnchorElement) => {
      link.addEventListener('click', (): void => {
        dropdown.classList.remove('active');
      });
    });

    // メニューの外側をクリックしたらメニューを閉じる
    document.addEventListener('click', (e: MouseEvent): void => {
      const target = e.target as HTMLElement;
      if (!dropdown.contains(target)) {
        dropdown.classList.remove('active');
      }
    });
  }
});
